import React from "react";
import { Box, Typography, Paper, Chip } from "@mui/material";
import { motion } from "framer-motion";
import { SERVICE_CATEGORIES } from "../components/ServiceData";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    x: -80,
    rotate: -4,
  },
  visible: {
    opacity: 1,
    x: 0,
    rotate: 0,
    transition: {
      type: "spring",
      stiffness: 120,
      damping: 16,
    },
  },
};

const ServiceCategories = () => {
  return (
    <Box sx={{ py: 6, overflowX: "hidden" }}>
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 800,
          mb: 4,
          background: "linear-gradient(90deg,#ff4d4d,#ff8080)",
          WebkitBackgroundClip: "text",
          color: "transparent",
        }}
      >
        Service Categories
      </Typography>

      {/* RUMMY SLIDER */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        style={{
          display: "flex",
          gap: "18px",
          overflowX: "auto",
          paddingBottom: "14px",
          paddingLeft: "8px",
        }}
      >
        {SERVICE_CATEGORIES.map((service, index) => (
          <motion.div
            key={service.code}
            variants={cardVariants}
            whileHover={{
              y: -12,
              scale: 1.04,
              rotate: 0,
              zIndex: 10,
            }}
            style={{
              minWidth: 280,
              maxWidth: 280,
              flexShrink: 0,
              marginLeft: index === 0 ? 0 : "-40px", // 🔥 overlap like rummy
            }}
          >
            <Paper
              sx={{
                p: 3,
                height: "100%",
                borderRadius: 3,
                background:
                  "linear-gradient(145deg, rgba(15,25,60,0.95), rgba(10,17,40,0.95))",
                border: "1px solid rgba(255,77,77,0.4)",
                boxShadow: "0 16px 40px rgba(0,0,0,0.45)",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 24px 60px rgba(255,77,77,0.35)",
                },
              }}
            >
              <Chip
                label={service.code}
                size="small"
                sx={{
                  mb: 1.2,
                  fontWeight: 700,
                  background: "rgba(255,77,77,0.18)",
                  color: "#ff4d4d",
                }}
              />

              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#fff", mb: 1 }}
              >
                {service.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.95rem",
                  color: "rgba(255,255,255,0.78)",
                  lineHeight: 1.6,
                }}
              >
                {service.description}
              </Typography>
            </Paper>
          </motion.div>
        ))}
      </motion.div>
    </Box>
  );
};

export default ServiceCategories;
